<template>
  <div class='Groups'>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-tabs
              v-model="tabs"
              fixed-tabs
              color="transparent"
              slider-color="iK"
              :key="tabsKey"
            >
              <v-tab :key="upAll" ripple>
                Cargar por CSV
              </v-tab>
              <v-tab :key="edit" ripple>
                Editar Formulario
              </v-tab>

              <v-tab-item :key="upAll">
                <v-card class="pa-3">
                  <v-card-text>
                    <v-select
                      :items="typeOfCSV"
                      v-model="csvType"
                      label="Tipo de CSV"
                      item-text="label"
                      item-value="id"
                    ></v-select>

                    <v-autocomplete v-if="csvType !== 'FC'"
                      :items="questions"
                      label="Pregunta"
                      v-model="selectQuest"
                      :disabled="loading"
                      color="secondary"
                      item-text="label"
                      item-value="id"
                      hide-no-data
                      hide-selected
                      :multiple="csvType === 'M' ? true : false"
                      :chips="csvType === 'M' ? true : false"
                      :deletable-chips="csvType === 'M' ? true : false"
                      @input="searchInput=null"
                      :search-input.sync="searchInput">
                    ></v-autocomplete>

                    <vue-csv-import :key="csvKey"
                      v-model="parseCsv"
                      :map-fields="mapFields">

                      <template slot="hasHeaders" slot-scope="{headers, toggle}">
                        <label>
                          <input
                            type="checkbox"
                            id="hasHeaders"
                            :value="headers"
                            @change="toggle"
                          >
                          ¿el archivo tiene cabeceras?
                        </label>
                      </template>

                      <template slot="error">
                        Tipo de archivo incorrecto
                      </template>

                      <template slot="thead">
                        <tr>
                          <th>Campos Requeridos</th>
                          <th>Campo a Cargar</th>
                        </tr>
                      </template>

                      <template slot="next" slot-scope="{load}">
                        <v-btn color="info" @click.prevent="load">Seleccionar campos</v-btn>
                      </template>
                    </vue-csv-import>
                  </v-card-text>

                  <v-alert
                    v-model="actualFields"
                    type="warning"
                  >
                    El operativo ya tiene fields y choices asignados.
                  </v-alert>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="info"
                      @click="openDialog('upload')"
                      :disabled="!parseCsv"
                    >
                      Cargar CSV
                      <v-icon right style="vertical-align: middle">cloud_upload</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>

              <v-tab-item :key="edit">
                <v-card class="pa-3">
                  <v-card-text>
                    <v-autocomplete
                      :items="originalForm"
                      label="Pregunta a Editar"
                      v-model="questionEdit"
                      :disabled="loading"
                      color="secondary"
                      item-text="label"
                      return-object
                      hide-no-data
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          large
                          :key="icon"
                          color="info"
                          @click="addQuestion()"
                        >edit</v-icon>
                      </template>
                    </v-autocomplete>
                  </v-card-text>

                  <v-card-text>
                    <v-expansion-panel focusable>
                      <v-expansion-panel-content
                        v-for="(question, index) in form"
                        :key="index"
                      >
                        <template v-slot:header>
                          <div>{{ question.id }}: {{ question.label }}</div>
                        </template>

                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 md9 lg10>
                                <v-layout row wrap>
                                  <v-flex xs12 sm4>
                                    <v-text-field
                                      v-model="question.id"
                                      label="Código"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm8>
                                    <v-text-field
                                      v-model="question.label"
                                      label="Pregunta"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm4>
                                    <v-select
                                      :items="types"
                                      v-model="question.type"
                                      label="Tipo de pregunta"
                                    ></v-select>
                                  </v-flex>

                                  <v-flex xs12 sm4>
                                    <v-text-field
                                      label="Capitulo"
                                      v-model="question.capitulo"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm4>
                                    <v-text-field
                                      label="Orden"
                                      v-model="question.order"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 md3 lg2>
                                <v-btn color="warning" @click="remove(index)">
                                  Cancelar Edición
                                </v-btn>
                              </v-flex>

                              <template v-if="question.type !== 'Abierta'">
                                <v-divider></v-divider>
                                <v-flex xs12
                                  v-for="(choice, index) in question.choices"
                                  :key="index"
                                >
                                  <v-card-text>
                                    <v-layout row wrap>
                                      <v-flex xs2>
                                        Opción {{ index + 1 }}:
                                      </v-flex>

                                      <v-flex xs2>
                                        <v-text-field
                                          v-model="choice.id"
                                          label="Código"
                                        ></v-text-field>
                                      </v-flex>

                                      <v-flex xs8>
                                        <v-text-field
                                          v-model="choice.label"
                                          label="Opción"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                </v-flex>
                              </template>

                              <v-flex xs12 v-if="question.type !== 'Abierta'">
                                <v-divider></v-divider>
                                <v-card-text v-if="choicesCSV">
                                  <vue-csv-import :key="csvChoicesKey"
                                    v-model="parseChoicesCsv"
                                    :map-fields="['id', 'label']">

                                    <template slot="hasHeaders" slot-scope="{headers, toggle}">
                                      <label>
                                        <input
                                          type="checkbox"
                                          id="hasHeaders"
                                          :value="headers"
                                          @change="toggle"
                                        >
                                        ¿el archivo tiene cabeceras?
                                      </label>
                                    </template>

                                    <template slot="error">
                                      Tipo de archivo incorrecto
                                    </template>

                                    <template slot="thead">
                                      <tr>
                                        <th>Campos Requeridos</th>
                                        <th>Campo a Cargar</th>
                                      </tr>
                                    </template>

                                    <template slot="next" slot-scope="{load}">
                                      <v-btn color="info" @click.prevent="load">Seleccionar campos</v-btn>
                                    </template>
                                  </vue-csv-import>
                                </v-card-text>

                                <v-card-actions>
                                  <v-btn
                                    color="info"
                                    @click="addChoice(index)"
                                    v-text="choicesCSV ? 'Agregar CSV' : 'Agregar Opción'"
                                  >
                                  </v-btn>

                                  <v-checkbox
                                    v-model="choicesCSV"
                                    label="Cargar desde CSV"
                                    color="info"
                                    hide-details
                                  ></v-checkbox>
                                </v-card-actions>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="info" @click="addQuestion()">
                      Agregar Pregunta
                    </v-btn>
                  </v-card-actions>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="info"
                      @click="openDialog('update')"
                      :disabled="form.length < 1"
                    >
                      Subir Cambios
                      <v-icon right style="vertical-align: middle">cloud_upload</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>

        <!-- <v-card-text>
          <pretty-json v-if="tabs === 0"
            :data="parseCsv"
          ></pretty-json>

          <pretty-json v-else
            :data="form"
          ></pretty-json>
        </v-card-text> -->
      </v-layout>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            color="error"
            dark
          >
            <v-toolbar-title>
              Aviso Importante:
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <span class="title">
              Cualquier cambio realizado afectara directamente la BD y no sera reversible.
            </span>
            <v-checkbox
              v-model="checkbox"
              label="Confirmo que deseo realizar esta operación"
            ></v-checkbox>
          </v-card-text>

          <v-alert :value="alert" type="error">
            No se ha podido realizar la operación.
          </v-alert>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="info"
              :disabled="loading"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              @click="save()"
              :disabled="!checkbox || loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
// import JsonPretty from 'vue-json-pretty'
// import JsonCSV from 'vue-json-csv'

import { VueCsvImport } from 'vue-csv-import'

export default {
  name: `Groups`,

  components: {
    // 'download-csv': JsonCSV,
    // 'pretty-json': JsonPretty,
    VueCsvImport
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.getQuestions()
    this.getQuestionsEdit()
  },

  data: function () {
    return {
      backConf: {
        path: '/formularios/operaciones/', // endpoint para subir los JSON de los fileds y choices
        pathEdit: '/formularios/editorfc/', // endpoint para cargar la encuesta actual
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      operativo: null,

      dialog: false,
      checkbox: false,
      alert: false,
      dialogMode: null,

      tabs: null,
      tabsKey: 0,

      questionBase: {
        'id': 'Código Nuevo',
        'label': 'Pregunta Nueva',
        'type': '',
        'capitulo': '',
        'order': '',
        'choices': []
      },
      optionBase: {
        'id': '',
        'label': ''
      },

      form: [],
      originalForm: [],
      questionEdit: null,

      types: ['Abierta', 'Multiple', 'Unica'],

      typeOfCSV: [
        { id: 'FC', label: 'Fiels y Choices' },
        { id: 'CNT', label: 'Constantes' },
        { id: 'M', label: 'Metas' }
      ],
      csvType: 'FC',

      questions: [],
      selectQuest: null,
      searchInput: null,

      mapFields: ['cod_pregunta', 'texto_pregunta', 'tipo', 'capitulo', 'order', 'cod_choice', 'texto_choice'],

      parseCsv: null,
      csvKey: 0,

      choicesCSV: null,
      parseChoicesCsv: null,
      csvChoicesKey: 0
    }
  },

  watch: {
    /**
     * Determina el tipo de CSV a subir, y los fields requeridos para el mismo
     */
    csvType: function () {
      if (this.csvType === 'FC') {
        this.mapFields = ['cod_pregunta', 'texto_pregunta', 'tipo', 'capitulo', 'order', 'cod_choice', 'texto_choice']
        this.csvKey += 1
      } else if (this.csvType === 'CNT') {
        this.mapFields = ['id', 'label']
        this.csvKey += 1
      }

      this.selectQuest = null
    },

    /**
     * Si el tipo de CSV a cargar es Muesta 'M', agrega los fields segun la lista de preguntas
     */
    selectQuest: function () {
      if (this.csvType === 'M') {
        this.mapFields = this.selectQuest.concat(['meta'])
        this.csvKey += 1
      }
      this.parseCsv = null
    },

    /**
     * Al cambiar la pestaña limpia las variables
     */
    tabs: function () {
      this.parseCsv = null
      this.form = []
    }
  },

  computed: {
    actualFields: function actualFields () {
      return this.questions.length > 0
    }

  },

  methods: {
    /**
     * Obtiene la lista de preguntas para el operativo
     */
    getQuestions () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.questions = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.questions = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Carga los datos de las encuestas
     */
    uploadData () {
      this.loading = true
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          opcion: this.csvType,
          pregunta: this.selectQuest,
          lista: this.parseCsv
        },
        url: this.backConf.path
      }
      console.log(JSON.stringify(request))
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.selectQuest = null
          t.parseCsv = null
          t.loading = false
          t.closeDialog()
          console.error(resp)
        })
        .catch(function (err) {
          t.loading = false
          t.alert = true
          console.error(err)
        })
    },

    /**
     * Obtiene la lista de preguntas para edición en el operativo
     */
    getQuestionsEdit () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathEdit
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.originalForm = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.originalForm = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Agrega una pregunta nueva al formulario
     */
    addQuestion () {
      if (this.questionEdit) {
        this.form.push(this.questionEdit)
        this.questionEdit = null
      } else {
        let question = JSON.parse(JSON.stringify(this.questionBase))
        this.form.push(question)
      }
    },

    /**
     * Agrega un choice a la pregunta
     * @param  {integer} index indice de la pregunta editada
     */
    addChoice (index) {
      if (this.choicesCSV) {
        this.form[index].choices = this.parseChoicesCsv
      } else {
        let option = JSON.parse(JSON.stringify(this.optionBase))
        this.form[index].choices.push(option)
      }
    },

    /**
     * Remueve una pregunta
     * @param  {integer} index indice de la pregunta editada
     */
    remove (index) {
      this.form.splice(index, 1)
    },

    /**
     * Envia el formulario actualizado
     */
    updateForm () {
      this.loading = true
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          lista: this.form
        },
        url: this.backConf.pathEdit
      }
      console.log(JSON.stringify(request))

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.questionEdit = null
          t.parseChoicesCsv = null
          t.loading = false
          t.closeDialog()
          console.error(resp)
        })
        .catch(function (err) {
          t.loading = false
          t.alert = true
          console.error(err)
        })
    },

    /**
     * Abre el dialogo y setea las variables con las que funciona
     * @param  {String} dialogMode Tipo de acción a realizar 'upload' o 'update'
     */
    openDialog (dialogMode) {
      this.dialog = true
      this.alert = false
      this.checkbox = false
      this.dialogMode = dialogMode
    },

    /**
     * Cierra el dialogo y setea las variables con las que funciona
     */
    closeDialog () {
      this.dialog = false
      this.alert = false
      this.checkbox = false
      this.dialogMode = null
    },

    /**
     * Realiza la accion correspondiente 'upload' o 'update'
     */
    save () {
      this.alert = false
      if (this.dialogMode === 'upload') {
        this.uploadData()
      }
      if (this.dialogMode === 'update') {
        this.updateForm()
      }
    }
  }
}
</script>

<style scoped>
  table {
    border: 2px solid #42b983;
    border-radius: 3px;
    background-color: #fff;
  }

  th {
    background-color: #42b983;
    color: rgba(255,255,255,0.66);
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  td {
    background-color: #f9f9f9;
  }

  th, td {
    min-width: 120px;
    padding: 10px 20px;
  }

  th.active {
    color: #fff;
  }

  th.active .arrow {
    opacity: 1;
  }
</style>
